import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { NotificationService } from '../../services/wealthlane-notification-services';

const usePostSeenNotification = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<boolean | undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        NotificationService.putApiNotificationApiAppNotificationNotificationSeen(payload)
      );
    },
    {
      onSuccess: async (response: boolean | undefined) => {
        if (response != null) {
          await queryClient.invalidateQueries('getGetUnseenNotificationList');
          await queryClient.invalidateQueries('getGetUnseenNotificationCountList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSeenNotification;
